var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("material-input", {
          attrs: {
            label: _vm.$t("account.name"),
            "on-type": "",
            "custom-expression": "newField.name",
          },
          model: {
            value: _vm.name,
            callback: function ($$v) {
              _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "name",
          },
        }),
        _vm._v(" "),
        _c(
          "material-input",
          {
            attrs: {
              value: _vm.type,
              label: _vm.$tc("global.words.type", 1),
              "custom-expression": "newField.type",
            },
          },
          [
            _c("select2", {
              ref: "select",
              attrs: {
                id: "definition-type-select",
                disabled: _vm.editing,
                data: _vm.typeDefinitionsOptions,
                value: _vm.type,
                name: "definition-type",
                options: _vm.options,
                "format-data": _vm.formatData,
                required: "",
              },
              on: { change: _vm.handleSelectChange },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isDropdown
          ? [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("edit-custom-dropdown-items", {
                    attrs: { values: _vm.dropdownItems },
                    on: {
                      editing: _vm.handleEditing,
                      input: _vm.handleDropdownInput,
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }